import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { InfoBoxDialog } from '../../dialogs/information-dialog/information-dialogue.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'formly-field-button',
  template: `
    <div>
      <button [type]="props.type" [style]="props.style"  (click)="openDialog()">
        {{ props.label }}
      </button>
    </div>
  `,
})
export class FormlyFieldButton extends FieldType {
  constructor(private dialog: MatDialog) {
    super()
  }
  onClick($event: Event) {
    console.log(this.props.description)
  }
  openDialog() {
    const dialogRef = this.dialog.open(InfoBoxDialog, {
      data:this.props.description
    });
  }
}
